module.exports = function (THREE) {
  return (function () {
    function d() {
      var k = {
        objects: [],
        object: {},
        vertices: [],
        normals: [],
        colors: [],
        uvs: [],
        materialLibraries: [],
        startObject: function (l, m) {
          if (this.object && this.object.fromDeclaration === false) {
            this.object.name = l;
            this.object.fromDeclaration = m !== false;
            return;
          }
          var o =
            this.object && typeof this.object.currentMaterial == "function"
              ? this.object.currentMaterial()
              : undefined;
          if (this.object && typeof this.object._finalize == "function") {
            this.object._finalize(true);
          }
          this.object = {
            name: l || "",
            fromDeclaration: m !== false,
            geometry: {
              vertices: [],
              normals: [],
              colors: [],
              uvs: [],
            },
            materials: [],
            smooth: true,
            startMaterial: function (q, r) {
              var u = this._finalize(false);
              if (u && (u.inherited || u.groupCount <= 0)) {
                this.materials.splice(u.index, 1);
              }
              var v = {
                index: this.materials.length,
                name: q || "",
                mtllib: Array.isArray(r) && r.length > 0 ? r[r.length - 1] : "",
                smooth: u === undefined ? this.smooth : u.smooth,
                groupStart: u === undefined ? 0 : u.groupEnd,
                groupEnd: -1,
                groupCount: -1,
                inherited: false,
                clone: function (w) {
                  var x = {
                    index: typeof w == "number" ? w : this.index,
                    name: this.name,
                    mtllib: this.mtllib,
                    smooth: this.smooth,
                    groupStart: 0,
                    groupEnd: -1,
                    groupCount: -1,
                    inherited: false,
                  };
                  x.clone = this.clone.bind(x);
                  return x;
                },
              };
              this.materials.push(v);
              return v;
            },
            currentMaterial: function () {
              if (this.materials.length > 0) {
                return this.materials[this.materials.length - 1];
              } else {
                return undefined;
              }
            },
            _finalize: function (q) {
              var r = this.currentMaterial();
              if (r && r.groupEnd === -1) {
                r.groupEnd = this.geometry.vertices.length / 3;
                r.groupCount = r.groupEnd - r.groupStart;
                r.inherited = false;
              }
              if (q && this.materials.length > 1) {
                for (var u = this.materials.length - 1; u >= 0; u--) {
                  if (this.materials[u].groupCount <= 0) {
                    this.materials.splice(u, 1);
                  }
                }
              }
              if (q && this.materials.length === 0) {
                this.materials.push({
                  name: "",
                  smooth: this.smooth,
                });
              }
              return r;
            },
          };
          if (o && o.name && typeof o.clone == "function") {
            var p = o.clone(0);
            p.inherited = true;
            this.object.materials.push(p);
          }
          this.objects.push(this.object);
        },
        finalize: function () {
          if (this.object && typeof this.object._finalize == "function") {
            this.object._finalize(true);
          }
        },
        parseVertexIndex: function (l, m) {
          var o = parseInt(l, 10);
          return (o >= 0 ? o - 1 : o + m / 3) * 3;
        },
        parseNormalIndex: function (l, m) {
          var o = parseInt(l, 10);
          return (o >= 0 ? o - 1 : o + m / 3) * 3;
        },
        parseUVIndex: function (l, m) {
          var o = parseInt(l, 10);
          return (o >= 0 ? o - 1 : o + m / 2) * 2;
        },
        addVertex: function (l, m, o) {
          var p = this.vertices;
          var q = this.object.geometry.vertices;
          q.push(p[l + 0], p[l + 1], p[l + 2]);
          q.push(p[m + 0], p[m + 1], p[m + 2]);
          q.push(p[o + 0], p[o + 1], p[o + 2]);
        },
        addVertexPoint: function (l) {
          var m = this.vertices;
          this.object.geometry.vertices.push(m[l + 0], m[l + 1], m[l + 2]);
        },
        addVertexLine: function (l) {
          var m = this.vertices;
          this.object.geometry.vertices.push(m[l + 0], m[l + 1], m[l + 2]);
        },
        addNormal: function (l, m, o) {
          var p = this.normals;
          var q = this.object.geometry.normals;
          q.push(p[l + 0], p[l + 1], p[l + 2]);
          q.push(p[m + 0], p[m + 1], p[m + 2]);
          q.push(p[o + 0], p[o + 1], p[o + 2]);
        },
        addColor: function (l, m, o) {
          var p = this.colors;
          var q = this.object.geometry.colors;
          if (p[l] !== undefined) {
            q.push(p[l + 0], p[l + 1], p[l + 2]);
          }
          if (p[m] !== undefined) {
            q.push(p[m + 0], p[m + 1], p[m + 2]);
          }
          if (p[o] !== undefined) {
            q.push(p[o + 0], p[o + 1], p[o + 2]);
          }
        },
        addUV: function (l, m, o) {
          var p = this.uvs;
          var q = this.object.geometry.uvs;
          q.push(p[l + 0], p[l + 1]);
          q.push(p[m + 0], p[m + 1]);
          q.push(p[o + 0], p[o + 1]);
        },
        addUVLine: function (l) {
          var m = this.uvs;
          this.object.geometry.uvs.push(m[l + 0], m[l + 1]);
        },
        addFace: function (m, q, v, w, x, y, z, A, B) {
          var C = this.vertices.length;
          var D = this.parseVertexIndex(m, C);
          var E = this.parseVertexIndex(q, C);
          var F = this.parseVertexIndex(v, C);
          this.addVertex(D, E, F);
          if (w !== undefined && w !== "") {
            var G = this.uvs.length;
            D = this.parseUVIndex(w, G);
            E = this.parseUVIndex(x, G);
            F = this.parseUVIndex(y, G);
            this.addUV(D, E, F);
          }
          if (z !== undefined && z !== "") {
            var H = this.normals.length;
            D = this.parseNormalIndex(z, H);
            E = z === A ? D : this.parseNormalIndex(A, H);
            F = z === B ? D : this.parseNormalIndex(B, H);
            this.addNormal(D, E, F);
          }
          this.addColor(D, E, F);
        },
        addPointGeometry: function (l) {
          this.object.geometry.type = "Points";
          var m = this.vertices.length;
          for (var o = 0, p = l.length; o < p; o++) {
            this.addVertexPoint(this.parseVertexIndex(l[o], m));
          }
        },
        addLineGeometry: function (l, m) {
          this.object.geometry.type = "Line";
          var o = this.vertices.length;
          var p = this.uvs.length;
          for (var q = 0, u = l.length; q < u; q++) {
            this.addVertexLine(this.parseVertexIndex(l[q], o));
          }
          var v = 0;
          for (u = m.length; v < u; v++) {
            this.addUVLine(this.parseUVIndex(m[v], p));
          }
        },
      };
      k.startObject("", false);
      return k;
    }
    function f(k) {
      this.manager = k === undefined ? THREE.DefaultLoadingManager : k;
      this.materials = null;
    }
    var g = /^[og]\s*(.+)?/;
    var h = /^mtllib /;
    var j = /^usemtl /;
    f.prototype = {
      constructor: f,
      load: function (k, l, m, o) {
        var p = this;
        var q = new THREE.FileLoader(p.manager);
        q.setPath(this.path);
        q.load(
          k,
          function (u) {
            l(p.parse(u));
          },
          m,
          o,
        );
      },
      setPath: function (k) {
        this.path = k;
        return this;
      },
      setMaterials: function (k) {
        this.materials = k;
        return this;
      },
      parse: function (J) {
        console.time("OBJLoader");
        var Q = new d();
        if (J.indexOf("\r\n") !== -1) {
          J = J.replace(/\r\n/g, "\n");
        }
        if (J.indexOf("\\\n") !== -1) {
          J = J.replace(/\\\n/g, "");
        }
        var X = J.split("\n");
        var Z = "";
        var a0 = "";
        var a1 = [];
        var a2 = typeof "".trimLeft == "function";
        for (var a3 = 0, a4 = X.length; a3 < a4; a3++) {
          Z = X[a3];
          if (
            (Z = a2 ? Z.trimLeft() : Z.trim()).length !== 0 &&
            (a0 = Z.charAt(0)) !== "#"
          ) {
            if (a0 === "v") {
              var a5 = Z.split(/\s+/);
              switch (a5[0]) {
                case "v":
                  Q.vertices.push(
                    parseFloat(a5[1]),
                    parseFloat(a5[2]),
                    parseFloat(a5[3]),
                  );
                  if (a5.length >= 7) {
                    Q.colors.push(
                      parseFloat(a5[4]),
                      parseFloat(a5[5]),
                      parseFloat(a5[6]),
                    );
                  } else {
                    Q.colors.push(undefined, undefined, undefined);
                  }
                  break;
                case "vn":
                  Q.normals.push(
                    parseFloat(a5[1]),
                    parseFloat(a5[2]),
                    parseFloat(a5[3]),
                  );
                  break;
                case "vt":
                  Q.uvs.push(parseFloat(a5[1]), parseFloat(a5[2]));
              }
            } else if (a0 === "f") {
              var a6;
              var a7 = Z.substr(1).trim().split(/\s+/);
              var a8 = [];
              for (var a9 = 0, aa = a7.length; a9 < aa; a9++) {
                if ((a6 = a7[a9]).length > 0) {
                  var ab = a6.split("/");
                  a8.push(ab);
                }
              }
              var ac = a8[0];
              a9 = 1;
              aa = a8.length - 1;
              for (; a9 < aa; a9++) {
                var ad = a8[a9];
                var ae = a8[a9 + 1];
                Q.addFace(
                  ac[0],
                  ad[0],
                  ae[0],
                  ac[1],
                  ad[1],
                  ae[1],
                  ac[2],
                  ad[2],
                  ae[2],
                );
              }
            } else if (a0 === "l") {
              var af = Z.substring(1).trim().split(" ");
              var ag = [];
              var ah = [];
              if (Z.indexOf("/") === -1) {
                ag = af;
              } else {
                var ai;
                for (var aj = 0, ak = af.length; aj < ak; aj++) {
                  if ((ai = af[aj].split("/"))[0] !== "") {
                    ag.push(ai[0]);
                  }
                  if (ai[1] !== "") {
                    ah.push(ai[1]);
                  }
                }
              }
              Q.addLineGeometry(ag, ah);
            } else if (a0 === "p") {
              var al = Z.substr(1).trim().split(" ");
              Q.addPointGeometry(al);
            } else if ((a1 = g.exec(Z)) !== null) {
              var am = (" " + a1[0].substr(1).trim()).substr(1);
              Q.startObject(am);
            } else if (j.test(Z)) {
              Q.object.startMaterial(
                Z.substring(7).trim(),
                Q.materialLibraries,
              );
            } else if (h.test(Z)) {
              Q.materialLibraries.push(Z.substring(7).trim());
            } else {
              if (a0 !== "s") {
                if (Z === "\0") {
                  continue;
                }
                throw new Error(
                  'THREE.OBJLoader: Unexpected line: "' + Z + '"',
                );
              }
              if ((a1 = Z.split(" ")).length > 1) {
                var an = a1[1].trim().toLowerCase();
                Q.object.smooth = an !== "0" && an !== "off";
              } else {
                Q.object.smooth = true;
              }
              if ((aB = Q.object.currentMaterial())) {
                aB.smooth = Q.object.smooth;
              }
            }
          }
        }
        Q.finalize();
        var ao = new THREE.Group();
        ao.materialLibraries = [].concat(Q.materialLibraries);
        a3 = 0;
        a4 = Q.objects.length;
        for (; a3 < a4; a3++) {
          var ap = Q.objects[a3];
          var aq = ap.geometry;
          var ar = ap.materials;
          var as = aq.type === "Line";
          var at = aq.type === "Points";
          var au = false;
          if (aq.vertices.length !== 0) {
            var av;
            var aw = new THREE.BufferGeometry();
            aw.setAttribute(
              "position",
              new THREE.Float32BufferAttribute(aq.vertices, 3),
            );
            if (aq.normals.length > 0) {
              aw.setAttribute(
                "normal",
                new THREE.Float32BufferAttribute(aq.normals, 3),
              );
            } else {
              aw.computeVertexNormals();
            }
            if (aq.colors.length > 0) {
              au = true;
              aw.setAttribute(
                "color",
                new THREE.Float32BufferAttribute(aq.colors, 3),
              );
            }
            if (aq.uvs.length > 0) {
              aw.setAttribute(
                "uv",
                new THREE.Float32BufferAttribute(aq.uvs, 2),
              );
            }
            var ax = [];
            for (var ay = 0, az = ar.length; ay < az; ay++) {
              var aA = ar[ay];
              var aB = undefined;
              if (this.materials !== null) {
                aB = this.materials.create(aA.name);
                if (!as || !aB || aB instanceof THREE.LineBasicMaterial) {
                  if (at && aB && !(aB instanceof THREE.PointsMaterial)) {
                    var aC = new THREE.PointsMaterial({
                      size: 10,
                      sizeAttenuation: false,
                    });
                    aD.copy(aB);
                    aB = aC;
                  }
                } else {
                  var aD = new THREE.LineBasicMaterial();
                  aD.copy(aB);
                  aD.lights = false;
                  aB = aD;
                }
              }
              if (!aB) {
                (aB = as
                  ? new THREE.LineBasicMaterial()
                  : at
                    ? new THREE.PointsMaterial({
                        size: 1,
                        sizeAttenuation: false,
                      })
                    : new THREE.MeshPhongMaterial()).name = aA.name;
              }
              aB.flatShading = !aA.smooth;
              aB.vertexColors = au ? THREE.VertexColors : THREE.NoColors;
              ax.push(aB);
            }
            if (ax.length > 1) {
              ay = 0;
              az = ar.length;
              for (; ay < az; ay++) {
                aA = ar[ay];
                aw.addGroup(aA.groupStart, aA.groupCount, ay);
              }
              av = as
                ? new THREE.LineSegments(aw, ax)
                : at
                  ? new THREE.Points(aw, ax)
                  : new THREE.Mesh(aw, ax);
            } else {
              av = as
                ? new THREE.LineSegments(aw, ax[0])
                : at
                  ? new THREE.Points(aw, ax[0])
                  : new THREE.Mesh(aw, ax[0]);
            }
            av.name = ap.name;
            ao.add(av);
          }
        }
        console.timeEnd("OBJLoader");
        return ao;
      },
    };
    return f;
  })();
};
